import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./Localization/Localization.jsx";
import { ToastContainer, Zoom } from "react-toastify";
import { BrowserRouter } from "react-router-dom";
import { UnreadMessageProvider } from "./Context/UnreadMessageContext.jsx";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <UnreadMessageProvider>
      <App />
      <ToastContainer
        position="bottom-left"
        theme="colored"
        transition={Zoom}
        draggable
        closeOnClick
      />
    </UnreadMessageProvider>
  </BrowserRouter>
);
